import {Placeholder} from 'react-bootstrap';

const ProductPagination = ({pagination=[],fetchData,categoryId,loading}) => {   
    const handleLoadMore = () => {
        const nextPage = pagination.current_page + 1;

        if (fetchData) {
            fetchData(categoryId,nextPage); 
        }
    };
    
    return(
        <div className="mt-5 d-flex flex-column text-center align-items-center">
           
                {loading?
                    <div className='d-flex'>
                        <Placeholder animation="glow" style={{ width: '80px', height: '20px' }}>
                            <Placeholder xs={2}/>
                        </Placeholder> 
                        / 
                        <Placeholder animation="glow" style={{ width: '80px', height: '20px' }}>
                            <Placeholder xs={2} />
                        </Placeholder>
                    </div>
                    : 
                    <span>
                        {pagination.items_shown_to} / {pagination.total_items}
                    </span>
                }
            
            {parseInt(pagination.current_page) < parseInt(pagination.pages_count) && (
                <button className="btn load-more" onClick={handleLoadMore} disabled={loading}>
                    {loading && (
                        <span className="spinner-border spinner-border-sm mx-1" role="status" aria-hidden="true"></span>
                    )}
                    <span className="sr-only">بیشتر</span>
                </button>
            )}
        </div>
    );
}

export default ProductPagination;